const diaryRouter = {
  route: null,
  name: null,
  title: '工作日志',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-tushuguanli',
  isElementIcon: false,
  filePath: 'view/diary/', // 文件路径
  order: null,
  inNav: true,
  children: [
    {
      title: '我的日志',
      type: 'view',
      name: 'DiaryList',
      route: '/diary/list/personal/calendar',
      filePath: 'view/diary/diary-list-personal-calendar.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      isElementIcon: false,
      permission: ['我的日志'],
    },
    // {
    //   title: '我的日志',
    //   type: 'view',
    //   name: 'DiaryList',
    //   route: '/diary/list/personal',
    //   filePath: 'view/diary/diary-list-personal.vue',
    //   inNav: true,
    //   icon: 'iconfont icon-tushuguanli',
    //   isElementIcon: false,
    //   permission: ['我的日志'],
    // },
    {
      title: '全部日志',
      type: 'view',
      name: 'DiaryList',
      route: '/diary/list',
      filePath: 'view/diary/diary-list.vue',
      inNav: true,
      icon: 'iconfont icon-tushuguanli',
      isElementIcon: false,
      permission: ['全部日志'],
    },
    /* {
      title: '添加日志',
      type: 'view',
      name: 'DiaryCreate',
      route: '/diary/add',
      filePath: 'view/diary/diary-add.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      isElementIcon: false,
    }, */
    {
      title: '日志看板',
      type: 'view',
      name: 'DiaryBoard',
      route: '/diary/board',
      filePath: 'view/diary/diary-board-list.vue',
      inNav: true,
      icon: 'iconfont icon-add',
      isElementIcon: false,
      permission: ['日志看板'],
    },
    {
      title: '工时统计',
      type: 'view',
      name: 'DiaryHourStatistics',
      route: '/diary/hour/statistics',
      filePath: 'view/diary/diary-statistics-overview',
      inNav: true,
      icon: 'iconfont icon-add',
      isElementIcon: false,
      permission: ['工时统计'],
    },
    {
      title: '会议纪要',
      type: 'view',
      name: 'DiaryHourStatistics',
      route: '/meeting/page',
      filePath: 'view/meeting/meeting-list',
      inNav: true,
      icon: 'iconfont icon-add',
      isElementIcon: false,
      permission: ['会议纪要'],
    },
    {
      title: '商务日志',
      type: 'view',
      name: 'DiaryHourStatistics',
      route: '/business/daily/page',
      filePath: 'view/businessDaily/business-daily-list',
      inNav: true,
      icon: 'iconfont icon-add',
      isElementIcon: false,
      permission: ['商务日志'],
    },
  ],
}

export default diaryRouter
